/**************************************************
 CONTROLLER: calendarViewModalController
**************************************************/
(function(){
    // add the controller
    SUGApp.controller('calendarViewModalController', calendarViewModalController);

    calendarViewModalController.$inject = ['$scope','$modalInstance', '$modal','$filter','$templateCache','$location','$q','$timeout','$window','SUGUtilities',
    'sugCacheFactory','errorService','profilePicService','signupPageService','theme','objDate','shortdformat','dateformat','tzshort', 'selectionHistoryArray',
    'memberId','listid', 'selectedSlotItems', 'isUserSignUpOwner', 'isUserSignUpAdmin', 'isLocked', 'arrUserSlotItems',
    'userSignUp','toggleSlotItem', 'getDateLabel', 'getQtyForMember','editItemMember', 'swapItemMember', 'signupInfo', 'openParticipantDetails'];

    function calendarViewModalController( $scope, $modalInstance, $modal, $filter, $templateCache, $location, $q, $timeout, $window, SUGUtilities,
        sugCacheFactory, errorService, profilePicService, signupPageService, theme, objDate, shortdformat, dateformat, tzshort, selectionHistoryArray,
        memberId, listid,  selectedSlotItems, isUserSignUpOwner, isUserSignUpAdmin, isLocked, arrUserSlotItems,
        userSignUp, toggleSlotItem, getDateLabel, getQtyForMember, editItemMember, swapItemMember, signupInfo, openParticipantDetails) {

        $scope.isProcessing = false;
        $scope.theme = theme;
        $scope.objDate = objDate;
        $scope.shortdformat = shortdformat;
        $scope.dateformat = dateformat;
        $scope.tzshort = tzshort;
        $scope.themestyles = '';
        $scope.showTimeColumn = false;
        $scope.showLocationColumn = false;
        $scope.showStacked = false; //Standard or Stacked layout

        //Participant Summary objects
        $scope.memberId = memberId;
        $scope.listid = listid;

        $scope.editItemMember = editItemMember;
        $scope.swapItemMember = swapItemMember;
        $scope.openParticipantDetails = openParticipantDetails;
        $scope.userSignUp = userSignUp;
        $scope.signupInfo = signupInfo;
        $scope.toggleSlotItem = toggleSlotItem;
        $scope.selectedSlotItems = selectedSlotItems;
        $scope.getQtyForMember = getQtyForMember;
        $scope.isLocked = isLocked;
        $scope.isUserSignUpAdmin = isUserSignUpAdmin;
        $scope.isUserSignUpOwner = isUserSignUpOwner;

        $scope.columnCount = 1;

        $scope.showPaymentMessage = false;
        $scope.paymentMessage = '';

        var slots = $scope.objDate.slots; //slots variable

        /* determine which columns, time and/or location, to show */
        for (var i = 0; i < slots.length; i++) {

            //see if any slots require payment message to be displayed.
            if (!$scope.showPaymentMessage) {
                $scope.showPaymentMessage = slots[i].showPaymentMessage;
                $scope.paymentMessage = ($scope.showPaymentMessage) ? slots[i].paymentMessage : '';
            }

            if (!$scope.showTimeColumn) {
                $scope.showTimeColumn = (slots[i].usetime == 1) ? true : false;
            }

            if (!$scope.showLocationColumn) {
                $scope.showLocationColumn = (slots[i].location.length > 0) ? true : false;
            }

            //column count = 2
            if ( (!$scope.showTimeColumn && $scope.showLocationColumn) || ($scope.showTimeColumn && !$scope.showLocationColumn) ) {
                $scope.columnCount = 2;
            }

            //column count = 3
            if ($scope.showTimeColumn && $scope.showLocationColumn) {
                $scope.showStacked = true;
                $scope.columnCount = 3;
            }

            //exit when everything has been satified
            if ($scope.showTimeColumn && $scope.showLocationColumn && $scope.showPaymentMessage) {
                break;
            }
        }


        /**
        * Edit Item Member
        * @param {Integer} - modalInfo, see getDeleteModalInfo for contents
        * @param {Integer} - itemmember, the itemmember to delete
        * @param {Integer} - itemmember, the itemmember to delete
        */
        $scope.editItemMember = function (itemmemberid,slotitemid,memberid) {

            //Dismiss model otherwise it gets in the way
            $scope.dismiss();

            //Common routine from signupController, used by reference
            editItemMember(itemmemberid,slotitemid,memberid);
        };

        /**
        * Deletes an item member. This version updates the Calandar View Modal
        * @param {Object} - modalInfo, see getDeleteModalInfo for contents
        * @param {Object} - itemmember, the itemmember to delete
        */
        $scope.deleteItemMember = function(modalInfo, itemmember) {
            // wait for the promise to resolve and if successful, delete the item member from the client side cache
            signupPageService.deleteItemMemberModal(modalInfo, itemmember).then(function (deleteInfo) {

                // delete the itemmember from the main participants array
                var participants = $scope.signupInfo.participants[modalInfo.slotitemid];
                $scope.signupInfo.participants[modalInfo.slotitemid] = participants.filter( function(itemmember){
                    return itemmember.itemmemberid != deleteInfo.itemmemberid;
                });

                // update the filterdata participants array for the slotitem
                var slots = $scope.objDate.slots; //slots variable
                var slotitemfound = false;
                var slotitem;

                /* locat the slot the slot item */
                for (var x = 0; x < slots.length; x++) {

                    var slotitems = slots[x].slotitems;

                    for (var z = 0; z < slotitems.length; z++) {
                        if (slotitems[z].slotitemid == deleteInfo.slotitemid) {
                            slotitemfound = true;
                            slotitem = slotitems[z];
                            break;
                        }
                    }

                    if (slotitemfound) { break; }
                }

                if (!slotitemfound ) { return; } //if not found, return

                //Remove UserSlotItem - updates external Calendar View buttons
                for( var u = 0; u < arrUserSlotItems.length; u++ ){
                    if (arrUserSlotItems[u].slotitemid === slotitem.slotitemid) {
                        arrUserSlotItems.splice(u, 1);
                        break;
                    }
                }

                // if slotitem found, update the participants array and quantity info for the item member
                slotitem.participants = $scope.signupInfo.participants[deleteInfo.slotitemid];

                if (!deleteInfo.waitlistsignup && slotitem.waitlistedparticipantcount > 0) {
                    // take the deleted signup myqty and remove from the waitlistedparticipantcount
                    // if the result of the waitlistedparticipantcount is negative, then remove that from the qtytaken and zero out the waitlistedparticipantcount

                    slotitem.waitlistedparticipantcount = (slotitem.waitlistedparticipantcount - slotitem.myqty);
                   
                    if (slotitem.waitlistedparticipantcount < 0) {
                        slotitem.qtytaken += slotitem.waitlistedparticipantcount;
                        slotitem.waitlistedparticipantcount = 0;
                    }
                }
                else if (deleteInfo.waitlistsignup) {
                    slotitem.waitlistedparticipantcount = Math.max(slotitem.waitlistedparticipantcount - slotitem.myqty, 0);
                    slotitem.qtytaken = Math.max(slotitem.qtytaken, 0);
                }
                else {
                    slotitem.qtytaken = Math.max(slotitem.qtytaken - slotitem.myqty, 0);
                }

                var stcAvailable = signupPageService.getAvailability( slotitem.qty, slotitem.qtytaken, slotitem.isaddlocked, $scope.isLocked(), slotitem.hidenumberwanted, slotitem.waitlist, signupPageService.getMemberParticipantData(slotitem.participants, $scope.memberId) );
                slotitem.qtyLabel = stcAvailable.qtyLabel;
                slotitem.qtyLabelResponsive = stcAvailable.qtyLabelResponsive;
                $scope.userSignUp.totalQty -= slotitem.myqty;
                slotitem.myqty = ( $scope.memberId ) ? $scope.getQtyForMember(slotitem.participants, $scope.memberId) : 0;

                slotitem.waitlistQtyLabel = signupPageService.getWaitlistAvailability(slotitem.waitlist, slotitem.waitlistedparticipantcount, slotitem.qty, slotitem.qtytaken);

                if (!$scope.signupInfo.hasavailableslots) {
                    $scope.signupInfo.hasavailableslots = true;
                    $scope.es.clearErrors();
                }

                slotitem.btnState = stcAvailable.btnState;
            });
        };


        /* View Specific Strings */
        $scope.strings = {
            lbls:   {
                  location:        'Location'
                , time:            'Time'
                , availableslot:   'Available Slot'
                , donation:        '($ Donation)'
            }

            , state: {
                  default:         'default'
                , selected:        'selected'
            }

            , errors:   {
                  errorsTitle:  ''
                , errorsPleaseCorrect:  'Please correct the issues indicated below.'
                , sorryNoSlotItemsSelected: 'You need to select at least one slot to proceed.'
                , modal: 'calendarviewmodal'
            }
        };

        //init error service
        $scope.es = errorService.newInstance();
        $scope.es.init();
        $scope.es.clearErrors();

        /* Tooltip vars */
        $scope.popTrig = 'mouseenter';
        $scope.popPlacement = 'top';
        $scope.popDelay = 300;

       /**
        * Toggles the slot item selection. Fires when the sign up button beside a slot item is pressed.
        * @param {Integer} slotitem the slotitemid
        */
        $scope.local_toggleSlotItem = function(slotitem) {

             $scope.es.clearErrors();

             var shouldAddToHistory = $scope.toggleSlotItem(slotitem, false); //Applies changes to the real selection (works better with Qty Limiting)

             if (shouldAddToHistory) {
                 selectionHistoryArray.push(slotitem); //This records changes and allows them to be undone upon cancel.
             }

        };

        /**
         * Handler for processing status -> will be used on save via broadcast event
         * @param {object}  event - broadcast event object
         * @param {boolean} isProcessing - when true disables form
         */
        $scope.$on('isProcessing', function (event, isProcessing) {

            $scope.isProcessing = isProcessing;

            disableForm(isProcessing);

            if ($scope.isProcessing) {
                SUGUtilities.showLoading('processing');
            }
        });


        /**
         * Manages disabling the form - Helper method
         * @param {boolean} blnDisabled - when true disables form
         */
        var disableForm = function (blnDisabled) {
            $scope.frmDisableField = blnDisabled;
        };


        // dismiss the modal
        $scope.dismiss = function () {
            $modalInstance.dismiss(false);
        };

        // close the modal
        $scope.close = function () {
            $modalInstance.dismiss(true);
        };

        //Formatted .date and .day object
        $scope.formatted = getDateLabel(objDate.jsDateOnly);

        /**
         * Function to kick off any initilization steps, such as data loading and setting defaults
         */
        var init = function(){
            //set the custom styles to match the theme
            $scope.themestyles = generateModalStyles($scope.theme, ' .calendarview-modal');
        };

        /**
         * Generate and return the dynamic CSS using the passed in sign up theme style values. Used in both the edit and public portal pages.
         * @param {Object} themecss - object containing colors to use in the generated styles
         * @param {String} classContainer - css selector of html element containing all content data
         */
        var generateModalStyles = function(themecss, classContainer, wrapperSelector){
            // if we have an empty themecss object return an empty string
            if( SUGUtilities.isUndefinedOrEmptyObject(themecss) ){
                return '';
            }
            classContainer = SUGUtilities.isDefinedNotNullNotEmpty(classContainer) ? classContainer : '';

            //generate the styles
            var themeStyles = '';

            //modal background
            if( themecss.backgroundcolor.length || themecss.backgroundimage.length){
                themeStyles += classContainer + ' .white-popup {';
                if( themecss.backgroundcolor.length ){ themeStyles += 'background-color: ' + themecss.backgroundcolor + ' !important; '; }
                if( themecss.backgroundimage.length ){ themeStyles += 'background-image: url("/images/theme/' + themecss.backgroundimage.split(/[/]+/).pop() + '") !important; '; }
                themeStyles += ' } ';
            }

            //modal title
            if( themecss.textcolor2.length ){
                themeStyles += classContainer + ' .calendarview-modal--title { color: ' + themecss.textcolor2 + '; font-weight:500; margin-bottom: 2px; }';
                themeStyles += classContainer + ' .calendarview-modal--date-dt { color: ' + themecss.textcolor2 + '; font-size: 2.2rem; font-weight: 700; }';
                themeStyles += classContainer + ' .calendarview-modal--date-day { color: ' + themecss.textcolor2 + '; }';
            }

            // date-time formatting
            if( themecss.textcolor1.length ){
                themeStyles += classContainer + ' .calendar-view--service-fee-msg { color: ' + themecss.textcolor1 + '; background-color: ' + themecss.backgroundcolor + ' }';
                themeStyles += classContainer + ' .participant-summary--name, .participant-summary--comment { color: ' + themecss.textcolor1 + ' }';
                themeStyles += classContainer + ' .calendarview-modal--location { border-top-color: ' + themecss.textcolor1 + '}';
                themeStyles += classContainer + ' .calendarview-modal--date-time { border-top-color: ' + themecss.textcolor1 + '}';
                themeStyles += classContainer + ' .calendarview-modal--date-time { color: ' + themecss.textcolor1 + '; font-weight:700; line-height: 1.43rem, font-size: 1.6rem }';
                themeStyles += classContainer + ' .calendarview-modal--calendar-dateformat { color: ' + themecss.textcolor1 + '; font-size: 1.3rem; opacity: .7; text-align: right; }';
                themeStyles += classContainer + ' .slot-title { color: ' + themecss.textcolor1 + '; }';
                themeStyles += classContainer + ' .slot-pmtwrap { color: ' + themecss.textcolor1 + '; }';
                themeStyles += classContainer + ' .slot-comment { color: ' + themecss.textcolor1 + '; }';
                themeStyles += classContainer + ' .SUGlink, .SUGLink, .SUGLink:hover  { color: ' + themecss.textcolor1 + '; text-decoration: none; }';
                themeStyles += classContainer + ' .slots-spacing { border-top-color: ' + themecss.textcolor1 + '}';
            }

            //will be used in when location is added
            themeStyles += classContainer + ' .calendarview-modal--loc-name { font-size: 96%; }';
            if( themecss.textcolor1.length ){
                themeStyles += classContainer + ' .loc-noaddress { color: ' + themecss.textcolor1 + '}';
            }

            //modal-close
            if( themecss.buttoncolor.length ){
                themeStyles += classContainer + ' button.modal-close { color: ' + themecss.textcolor2 + ' !important; }';
            }

            //slot image
            themeStyles += classContainer + ' .calendarview-modal--slot-image { max-height:110px; border-radius: 6px; margin-bottom: 8px; ';
            if( themecss.tableheaderbackground.length ){
                themeStyles += ' border:1px solid ' + themecss.tableheaderbackground + '; }';
            } else {
                themeStyles += '}';
            }

            //table body solid background color
            themeStyles += classContainer + ' tbody { ';
            if( themecss.backgroundcolor.length ){
                themeStyles += ' background-color: ' + themecss.backgroundcolor + '; }';
            } else {
                themeStyles += '}';
            }

            //table
            themeStyles += classContainer + ' .sTable, .sTableSmall {margin-bottom: 8px;}';
            if( themecss.textcolor1.length ){
                themeStyles += classContainer + ' table .table, .sTable, .sTableSmall { border-top: 3px solid ' + themecss.textcolor1 + '; ';
                themeStyles += ' border-right: 1px solid ' + themecss.textcolor1 + '; ';
                themeStyles += ' border-bottom: 3px solid ' + themecss.textcolor1 + '; ';
                themeStyles += ' border-left: 1px solid ' + themecss.textcolor1 + '; ';

                themeStyles += '}';
                themeStyles += classContainer + ' .nestedTable, .tcell { border-left: 1px solid ' + themecss.textcolor1 + ';}';
            }

            //table header
            themeStyles += classContainer + ' table thead { ';
            if( themecss.tableheaderbackground.length ){ themeStyles += ' background-color: ' + themecss.tableheaderbackground + ' !important; '; }
            if( themecss.tableheadertext.length ){ themeStyles += ' color: ' + themecss.tableheadertext + ' !important; '; }
            if( themecss.tableheaderimage.length ){ themeStyles += ' background-image: url(' + themecss.tableheaderimage + ') !important; '; }
            themeStyles += '}';

            //table thead links
            if( themecss.tableheadertext.length ){
                themeStyles += classContainer +

                ' .tableheader { color: ' + themecss.tableheadertext + ' !important; } ';
            }

            //calendarview table rows
            if( themecss.textcolor1.length ){

                themeStyles += classContainer +
                ' .tableheader { border-bottom: 2px solid ' + themecss.textcolor1 + ' !important; } ';

                themeStyles += classContainer +
                ' .nestedTableCell { border-left: 1px solid ' + themecss.textcolor1 + ' !important; border-bottom: 1px solid ' + themecss.textcolor1 + ' !important; } ';

                themeStyles += classContainer +
                ' .nestedTableCellLast { border-left: 1px solid ' + themecss.textcolor1 + ' !important; border-bottom: 0p !important; } ';

            }

            //for some reason if this line is removed the badge styling breaks
            themeStyles += classContainer + ' .pseudo {} ';

            if( themecss.buttontextcolor.length && themecss.buttoncolor.length ){
                themeStyles += ' .badge { color: ' + themecss.buttontextcolor + ' !important; background-color: ' + themecss.buttoncolor + ' } ';
            }

            return themeStyles;
        };

        /**
         * Wrapper for the profilePicService method, this is so that we can easily add additional functionality specific to the participant summary later
         */

        //This will be needed when user data is flushed out
        $scope.parseProfilePicData = function(participant){
            return profilePicService.parseProfilePicData(participant);
        };

        //product images controller
        var showImageController = ['$scope','$modalInstance','productImageObject', function($scope, $modalInstance, productImageObject) {
            $scope.productImageObject = productImageObject;

            $scope.dismiss = function () {
                $modalInstance.dismiss(false);
            };
        }];

        /**
         * Bootstrap AngularJS Modal for when user clicks on slot image zoom icon
         * @param {object} productImageObject - product image object
         * @param {string} productImageObject.itemname - display the name of the sign up item
         * @param {string} productImageObject.images[] - product image URLs
         * @param {string} productImageObject.itemdescription - item description
         */
        $scope.showImages = function( productImageObject ){
            return $modal.open({
                templateUrl:  '/view/signups/dspItemImages-modal.html',
                controller:   showImageController,
                resolve: {
                    productImageObject: function () {
                        return productImageObject;
                    },
                }
            }).result;
        };

        //save and continue
        $scope.saveandcontinue = function() {

            //We have a selection, we can proceed
            if ( $scope.selectedSlotItems.length ) {
                $scope.es.clearErrors();
                $modalInstance.close({saveandcontinue: true});
            } else {

                //throw error (matches all calendar view behavior.)
                $scope.es.setError($scope.strings.errors.modal, $scope.strings.errors.sorryNoSlotItemsSelected);
            }
        };

        //save and continue
        $scope.selectotherdays = function() {
            $scope.es.clearErrors();
            $modalInstance.close({saveandcontinue: false});
        };

        init();
    }
}());
